import type { TableMergedState } from 'components/Table/model/TableModel';

export const selectTableSupportsSelectAll = (s: TableMergedState): boolean =>
  s.loadRowIdsForSelectAll !== undefined && !s.disableSelectAll;
